export default "__VITE_ASSET__BE4Gdj0q__";